export default __webpack_public_path__ + "static/media/danger.6cc68f2a.svg";